import { useState } from 'react';
import PropTypes from 'prop-types';
import PanelContainer from '../panel/panelContainer';
import PanelFlap from '../panelFlap/panelFlap';
import PanelGroupPropTypes from './panelGroupPropTypes';
import PanelGroupModel from './panelGroupModel';
import useResetViewerHighlights from './hooks/useResetViewerHighlights';
import BackToReadingButton from '../../buttons/backToReadingButton/backToReadingButton';

export default function PanelGroup(
  {
    closeAllPanels, panelGroup, updatedPosition,
  },
) {
  const {
    panels, config: { panelLimit }, userInitiatedUpdate, offset,
  } = panelGroup;
  const panelsCount = panels.length;

  const [panelGroupModel] = useState(new PanelGroupModel(panelLimit, userInitiatedUpdate));
  const panelModels = panelGroupModel.applyPanels(
    userInitiatedUpdate, panels, offset, updatedPosition,
  );

  useResetViewerHighlights(panels);

  return (
    <>
      {panelsCount > 0 && panelGroupModel.hasMultipleColumns && (
        <PanelFlap
          panel={panelModels[0]}
          visible={panelsCount > 1}
          updatedPosition={updatedPosition}
        >
          <BackToReadingButton onClick={closeAllPanels} />
        </PanelFlap>
      )}
      {panelModels.map(({ panel, ...props }) => (
        <PanelContainer key={panel.id} panel={panel} {...props} />
      ))}
    </>
  );
}

PanelGroup.propTypes = {
  panelGroup: PropTypes.shape(PanelGroupPropTypes).isRequired,
  closeAllPanels: PropTypes.func.isRequired,
  updatedPosition: PropTypes.number.isRequired,
};
